import { supabase } from './supabase';
import type { RoleType, UsersMetadataRow } from './database.types';

export interface AppUser {
  id: string;
  email: string | null;
  metadata: UsersMetadataRow | null;
}

export async function signInWithPassword(
  email: string,
  password: string,
): Promise<{ error: string | null }> {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  return { error: error?.message ?? null };
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut();
}

export async function fetchUserMetadata(userId: string): Promise<UsersMetadataRow | null> {
  const { data, error } = await supabase
    .from('users_metadata')
    .select('*')
    .eq('user_id', userId)
    .maybeSingle();
  if (error) {
    console.warn('fetchUserMetadata error', error.message);
    return null;
  }
  return data;
}

export const ROLE_LABELS: Record<RoleType, string> = {
  super_admin: 'Super admin',
  direction: 'Direction',
  responsable_activite: "Responsable d'activité",
  commercial: 'Commercial',
  comptable: 'Comptable',
  formateur: 'Formateur',
  responsable_rh: 'Responsable RH',
  responsable_marketing: 'Responsable marketing',
};

export function isAdminRole(role: RoleType | null | undefined): boolean {
  return role === 'super_admin' || role === 'direction';
}
